<template>
  <v-card>
    <v-card-title>
      Referrals
      <v-chip class="ml-2" small v-if="total">
        {{ total }}
      </v-chip>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="referrals"
      :loading="loading"
      :server-items-length="total"
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      @update:page="getReferrals"
      @update:items-per-page="getReferrals"
    >
      <template #[`item.created_at`]="{ item }">
        {{ formatDate(item.created_at) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import store from '@/store'
import { ref, onMounted, computed, watch } from '@vue/composition-api'
import { formatDate } from '@core/date/dateFunctions'

export default {
  name: 'PartnerReferralList',
  props: {
    partnerId: {
      type: [Number, String],
      required: true
    }
  },
  setup(props) {
    const loading = ref(false)
    const page = ref(1)
    const itemsPerPage = ref(10)

    const headers = [
      { text: 'Reference', value: 'code' },
      { text: 'Amount', value: 'amount' },
      { text: 'User', value: 'user.name' },
      { text: 'Date', value: 'created_at' },
    ]

    const referrals = computed(() => store.getters['referral/referrals'])
    const total = computed(() => store.getters['referral/total'])

    const getReferrals = () => {
      loading.value = true
      store.dispatch('referral/getReferralsList', {
        page: page.value,
        field: {
          paginate: itemsPerPage.value,
          partner_id: props.partnerId
        }
      }).then(() => {
        loading.value = false
      })
    }

    watch(() => props.partnerId, () => {
        getReferrals()
    })

    onMounted(getReferrals)

    return {
      headers,
      referrals,
      total,
      loading,
      page,
      itemsPerPage,
      getReferrals,
      formatDate
    }
  }
}
</script>
